import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from '@codex/basics';
import scrollToElement from 'scroll-to-element';
import { EnvironmentThemeProvider } from '@codex-brightworld/themes';

const CareplanHeaderWrapper = styled.div`
  margin: 32px 0 16px;
  h2 {
    font-weight: normal;
    font-size: 18px !important;
  }    
`;

const MoreInfo = styled(Link)`
  float: right;
  font-size: 14px !important;
  color: ${(props) => props.theme.colors.primary.purple};
  &:hover {
    color: ${(props) => props.theme.colors.primary.purple};
  }
`;

const CareplanHeader = ({ label, linkTranslation }) => {

  const handleClick = () => {
    const el = document.querySelector('[href="#tab5"]');
    el.click();
    setTimeout(() => {
      scrollToElement('#careplan', {
        offset: -80,
        ease: 'linear',
        duration: 300
      });
    }, 500);
  };

  return (
    <EnvironmentThemeProvider>
      <CareplanHeaderWrapper>
        <h2 className={'section-title'}>
          {label}
          <MoreInfo
            onClick={handleClick}
            data-interaction={'More Info - Care Services'}
          >
            {linkTranslation}
          </MoreInfo>
        </h2>
      </CareplanHeaderWrapper>
    </EnvironmentThemeProvider>
  );
};

CareplanHeader.displayName = 'CareplanHeader';

CareplanHeader.propTypes = {
  label: PropTypes.string.isRequired,
  linkTranslation: PropTypes.string
};

CareplanHeader.defaultProps = {
  linkTranslation: 'More info'
};

export default CareplanHeader;
